/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEpisodeInfo,
    JsonEpisodeInfoFromJSON,
    JsonEpisodeInfoFromJSONTyped,
    JsonEpisodeInfoToJSON,
} from './JsonEpisodeInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEpisodeInfo
 */
export interface ApiResultOfJsonEpisodeInfo {
    /**
     * 
     * @type {JsonEpisodeInfo}
     * @memberof ApiResultOfJsonEpisodeInfo
     */
    data?: JsonEpisodeInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEpisodeInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEpisodeInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEpisodeInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEpisodeInfo
     */
    result?: ApiResultOfJsonEpisodeInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEpisodeInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEpisodeInfoFromJSON(json: any): ApiResultOfJsonEpisodeInfo {
    return ApiResultOfJsonEpisodeInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonEpisodeInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEpisodeInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEpisodeInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEpisodeInfoToJSON(value?: ApiResultOfJsonEpisodeInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEpisodeInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

